import { useEffect } from 'react';
import AnimationScrollPage from '../../../../components/AnimationScrollPage';

const NoAccessoriesMessage = () => {

  const {
    apiFailureMessage,
  } = window.HONDA_SHOP_ACCESSORIES;

  useEffect(() => {
    new AnimationScrollPage().init();
  }, []);

  return (
    <div className="animation">
      <div className="anima-bottom delay-2">
        <p dangerouslySetInnerHTML={{ __html: apiFailureMessage }} />
      </div>
    </div>
  );
};

export default NoAccessoriesMessage;